export const BC_FETCH_ALL_FANS_REQUEST = 'BC_FETCH_ALL_FANS_REQUEST';
export const BC_FETCH_ALL_FANS_SUCCESS = 'BC_FETCH_ALL_FANS_SUCCESS';
export const BC_FETCH_ALL_FANS_ERROR   = 'BC_FETCH_ALL_FANS_ERROR';

export const FETCH_BC_FAN_BY_ID_REQUEST   = 'FETCH_BC_FAN_BY_ID_REQUEST';
export const FETCH_BC_FAN_BY_ID_SUCCESS   = 'FETCH_BC_FAN_BY_ID_SUCCESS';
export const FETCH_BC_FAN_BY_ID_ERROR   = 'FETCH_BC_FAN_BY_ID_ERROR';
